export enum BreadcrumbSeasonsGroup {
  ALL_ACTIVES = 'ALL_ACTIVES',
  BY_SEASON = 'BY_SEASON'
}
